import { create } from "zustand";

import { detectBrowserLanguage } from "@/localization/detectLanguage.ts";

type Language = "en" | "de";

interface LanguageStore {
	lang: Language;
	setLang: (lang: Language) => void;
}

export const useLanguageStore = create<LanguageStore>((set) => ({
	lang: detectBrowserLanguage(),
	setLang: (lang) => set({ lang })
}));
